<script setup>

import { inject, ref, watch, computed } from 'vue';

import Tree from 'primevue/tree';
import TypeObjet from './TypeObjet.vue';
import ModaleEditionTypeObjet from '@/components/modales/ModaleEditionTypeObjet.vue';

const { typesObjet } = defineProps({
	typesObjet: Array
});

const selectionSchema = inject('selectionSchema');
const selectionnerChamp = inject('selectionnerChamp');

const selection = ref(getSelectionTypeObjet(selectionSchema.value.typeObjet));
const nouveauTypeObjet = ref(null);

const arbre = computed(() => {
	const noeuds = [];
	typesObjet.filter(typeObjet => !typeObjet.idTypeObjetPere).sort(comparerTypesObjet).forEach(typeObjet => ajouterNoeud(typeObjet, noeuds));
	return noeuds;
});

watch(() => selectionSchema.value.typeObjet, (typeObjet) => {
	if (typeObjet && (!selection.value || !selection.value[typeObjet.id])) {
		selection.value = getSelectionTypeObjet(typeObjet);
	}
});

function ajouterNoeud(typeObjet, noeuds) {
	const sousNoeuds = [];
	typesObjet.filter(typeObj => typeObj.idTypeObjetPere === typeObjet.id).sort(comparerTypesObjet).forEach(typeObj => ajouterNoeud(typeObj, sousNoeuds));
	const noeud = {key: typeObjet.id, label: typeObjet.nom, data: typeObjet, children: sousNoeuds};
	noeuds.push(noeud);
}

function getSelectionTypeObjet(typeObjet) {
	const selection = {};
	if (typeObjet) {
		selection[typeObjet.id] = true;
	}
	return selection;
}

function gererSelectionNoeud(noeud) {
	const typeObjet = noeud.data;
	const premierChamp = (noeud.data.champs.length > 0 ? noeud.data.champs[0] : null);
	selectionnerChamp(typeObjet, premierChamp);
}

function comparerTypesObjet(typeObjet1, typeObjet2) {
	return typeObjet1.nom.localeCompare(typeObjet2.nom);
}

function ajouterTypeObjet() {
	nouveauTypeObjet.value = {};
}

function fermerModaleNouveauTypeObjet(typeObjetCree) {
	nouveauTypeObjet.value = null;
	const premierChamp = (typeObjetCree.champs.length > 0 ? typeObjetCree.champs[0] : null);
	selectionnerChamp(typeObjetCree, premierChamp);
}

</script>

<template>
	<div>
		<div class="entete">
			<label class="titre">Types d'objet</label>
			<button class="bouton fa-solid fa-plus" @click="ajouterTypeObjet()" />
		</div>
		<Tree v-if="typesObjet.length"
			class="arbre-types-objet"
		  :value="arbre" 
		  selectionMode="single"
		  v-model:selectionKeys="selection"
		  @node-select="(noeud) => gererSelectionNoeud(noeud)" >
			<template #default="slotProps">
				<TypeObjet :type-objet="slotProps.node.data" :selectionne="slotProps.node.data == selectionSchema.typeObjet" />
			</template>
		</Tree>
		<div v-else class="aucun-type-objet">Aucun type d'objet</div>
		<ModaleEditionTypeObjet 
		v-if="nouveauTypeObjet"
		:type-objet-edite="nouveauTypeObjet"
		@fermeture="fermerModaleNouveauTypeObjet"/>
	</div>
</template>

<style scoped>

.arbre-types-objet {
	overflow: auto;
	height: 15vh !important;
}

.aucun-type-objet {
	border: 1px solid var(--couleur-bordure);
	font-style: italic;
	height: 15vh !important;
	padding: 5px;
	user-select: none;
}

.entete {
	display: flex;
	justify-content: space-between;
	align-items: center;
	margin: 2px;
}

</style>